module.exports = __webpack_public_path__ + "img/chapter-1-thumb.d46b2bd5.jpg";